import { useFela } from 'react-fela';
import { FormattedMessage, useIntl } from 'react-intl';

import { useConfirmationModal } from '@/modules/modals';
import { Button, ButtonType, IconButton, Text } from '@/modules/ui';

import { useRevokeApiKeys } from '../../../hooks';
import * as felaRules from './BatchActions.rules';

export interface BatchActionsProps {
    apiKeyIds: string[];
    onClear: () => void;
}

export const BatchActions = ({ apiKeyIds, onClear }: BatchActionsProps) => {
    const { css } = useFela();
    const { formatMessage } = useIntl();
    const { openConfirmationModal } = useConfirmationModal();
    const { mutateAsync: revokeApiKeys } = useRevokeApiKeys();

    const count = apiKeyIds.length;

    const confirmRevoke = () => {
        openConfirmationModal({
            title: formatMessage({ id: 'api-keys.batchRevoke.title' }, { count }),
            content: formatMessage({ id: 'api-keys.batchRevoke.content' }, { count }),
            confirmButtonText: formatMessage({ id: 'api-keys.batchRevoke.confirm' }),
            cancelButtonText: formatMessage({ id: 'api-keys.batchRevoke.cancel' }),
            onConfirm: async () => {
                await revokeApiKeys(apiKeyIds);
                onClear();
            },
        });
    };

    return (
        <div className={css(felaRules.container)}>
            <Text variant='ParagraphNormalMedium' color='foregroundsPrimary' customStyle={felaRules.label}>
                <FormattedMessage id='api-keys.table.batchActions.selected' values={{ count }} />
            </Text>
            <Button type={ButtonType.TEXT} customStyle={felaRules.deleteButton} onClick={confirmRevoke}>
                <FormattedMessage id='api-keys.table.batchActions.delete' />
            </Button>
            <IconButton
                type='ghost'
                icon='x'
                customStyle={felaRules.clearButton}
                aria-label={formatMessage({ id: 'api-keys.table.batchActions.clear' })}
                onClick={onClear}
            />
        </div>
    );
};
